import React, {useEffect, useState} from "react";
import {Button, Col, Modal, Row, Table} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import moment from "moment";
import {
    checkPermission,
    getCurrentUser,
    getGreekCurrencyFormat, isEmpty, truncateHTML
} from "../../../_helpers/commonFunctions";
import {
    fetchDashboardData,
    triggerCleanFailedSyncs,
    triggerSyncProviderInvoices
} from "../../../_apis/api";
import {resetDashboardGraphSettings, setNewsData} from "../../../_reducers/companySlice";
import OverviewChart2 from "../../../dashboardComponents/OverviewChart2";
import SmallClientChart from "../../../dashboardComponents/SmallClientChart";
import {openTabByType} from "../../../_helpers/tabOpeners";
import {toast} from "react-toastify";
import {MdCleaningServices} from "react-icons/md";
import {FaArrowsRotate} from "react-icons/fa6";

const Start = () => {
    const dispatch = useDispatch();
    const aiSettings = useSelector((state) => state.AI.aiSettings);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const dashboardData = useSelector((state) => state.COMPANY_DATA.dashboardData);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const newsData = useSelector((state) => state.COMPANY_DATA.newsData);
    const syncInvoicesProviderLog = useSelector((state) => state.SALES_SETTINGS.syncInvoicesProviderLog);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const currentUser = getCurrentUser();
    const [updateLoader, setUpdateLoader] = useState(false);
    const [showLogModal, setShowLogModal] = useState(false);
    const [displayedLogs, setDisplayedLogs] = useState([]);
    const [syncLoader, setSyncLoader] = useState(false);
    const [showNewsModal, setShowNewsModal] = useState(false);
    const [activeNewsArticle, setActiveNewsArticle] = useState(null);

    const canSeeAI = checkPermission("custom-ai", permissionsData) && aiSettings?.enableCloudAI === true;
    const betterDashboard = checkPermission("custom-dashboarddata", permissionsData) === true;

    const isDemoCompany = companyDetails?.isDemoCompany === true;
    const [showConfirmReset, setShowConfirmReset] = useState(false);

    useEffect(() => {
        if (newsData.length === 0) fetchArticles();
    }, []);

    const fetchArticles = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/fetch-articles`, {
            headers: {'Content-Type': 'application/json'},
            params: {
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setNewsData(res.data.data));
            }
        }).catch(error => {
            console.log(error);
        })
    }

    const setShowModal = (logId) => {
        const logs = syncInvoicesProviderLog?.syncs.find((sync) => sync._id === logId);
        if (logs?.logs && logs.logs.length > 0) {
            setDisplayedLogs(logs.logs);
        }
        setShowLogModal(true);
    }

    const formatGreekName = (name, isLastName = false) => {
        if (isLastName && String(name).endsWith("ος")) {
            return String(name).slice(0, -2) + "ε";
        }
        if (String(name).endsWith("ιος")) {
            return String(name).slice(0, -3) + "ιε";
        } else if (String(name).endsWith("ς")) {
            return String(name).slice(0, -1);
        }
        return name;
    }

    const bottomBoxHeight = "max(380px, calc(100vh - 650px))";

    const firstBoxStyle = {
        position: "relative",
        height: "100%",
        width: "100%",
        borderRadius: "12px",
        backgroundColor: "#635BFF",
        boxShadow: "0px 2px 4px -1px gray",
        padding: "25px",
        color: "white",
        fontWeight: "500",
        fontSize: company.year === moment().year() ? "18px" : "22px",
        minHeight: "190px",
    }

    const clientBoxStyle = {
        position: "relative",
        height: "100%",
        width: "100%",
        borderRadius: "12px",
        backgroundColor: "#f4f7fb",
        boxShadow: "0px 2px 4px -1px lightgray",
        color: "black",
        fontWeight: "400",
        fontSize: "18px",
        minHeight: "180px",
    }

    const monthlySalesBoxStyle = {
        position: "relative",
        height: "100%",
        width: "100%",
        borderRadius: "12px",
        backgroundColor: "#f4f7fb",
        boxShadow: "0px 2px 4px -1px lightgray",
        padding: "25px",
        color: "black",
        fontWeight: "400",
        fontSize: company.year === moment().year() ? "18px" : "24px",
        minHeight: "180px",
    }

    const monthlyClientPaymentsBoxStyle = {
        position: "relative",
        height: "100%",
        width: "100%",
        borderRadius: "12px",
        backgroundColor: "#f4f7fb",
        boxShadow: "0px 2px 4px -1px lightgray",
        padding: "25px",
        color: "black",
        fontWeight: "400",
        fontSize: company.year === moment().year() ? "18px" : "24px",
        minHeight: "180px",
    }

    const handleNewsClick = (article) => {
        setActiveNewsArticle(article);
        setShowNewsModal(true);
    }

    const handleCloseNewsModal = () => {
        setShowNewsModal(false);
        setActiveNewsArticle(null);
    }

    const handleOpenAIModule = () => {
        dispatch(openTabByType("ai-module", TABS_DATA));
    }

    const handleResetDemoCompany = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/company/reset-demo-company`, {
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                setShowConfirmReset(false);
                toast.success("Επιτυχής ενέργεια.");
                setTimeout(() => {
                    window.location.reload();
                }, 500)
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <div>
            <Row>
                <Col md={12} className={"d-flex justify-content-end"}>
                    {isDemoCompany && (
                        <Button size={"sm"} className={"mb-2 mr-2"} onClick={() => setShowConfirmReset(true)}>
                            Επαναφορά Δοκιμαστικής Εταιρείας
                        </Button>
                    )}
                    {canSeeAI && (
                        <Button size={"sm"} className={"mb-2 mr-2"} onClick={() => handleOpenAIModule()}>
                            ✨ Primer AI
                        </Button>
                    )}
                    {betterDashboard && (
                        <Button
                            disabled={updateLoader}
                            className="mb-2"
                            size="sm"
                            onClick={() => {
                                fetchArticles();
                                dispatch(resetDashboardGraphSettings());
                                dispatch(fetchDashboardData(company.id, company.year, setUpdateLoader, null, true));
                            }}>
                            Ενημέρωση Σελίδας
                            {!updateLoader && (
                                <i className="fa-solid fa-rotate ml-1" style={{fontSize: "12px"}}></i>
                            )}
                            {updateLoader && (
                                <span
                                    className="spinner-border spinner-border-sm ml-1"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            )}
                        </Button>
                    )}
                </Col>
            </Row>
            {betterDashboard ? (
                <React.Fragment>
                    <Row>
                        <Col md={6}>
                            <Row className={"pt-1"}>
                                <Col md={6}>
                                    <div style={firstBoxStyle}>
                                        <span>{Number(moment().format("HH")) < 12 ? "Καλημέρα" : "Καλησπέρα"} {formatGreekName(currentUser.firstName)} {formatGreekName(currentUser.lastName, true)}, καλώς ορίσατε στο Primer ERP!</span>
                                        {company.year === moment().year() &&
                                            <Row style={{fontSize: "14px", marginTop: "40px"}}>
                                                <Col md={6} style={{borderRight: "1px solid gray"}}>
                                                    <span style={{opacity: "0.75"}}>Σημερινές Πωλήσεις</span>
                                                    <br/>
                                                    <span
                                                        style={{fontSize: "18px"}}>{getGreekCurrencyFormat(dashboardData.todaySales)}</span>
                                                </Col>
                                                <Col md={6}>
                                                    <span style={{opacity: "0.75"}}>Χθεσινές Πωλήσεις</span>
                                                    <br/>
                                                    <span
                                                        style={{fontSize: "18px"}}>{getGreekCurrencyFormat(dashboardData.yesterdaySales)}</span>
                                                </Col>
                                            </Row>
                                        }
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div style={clientBoxStyle}>
                                        <div style={{paddingLeft: "25px", paddingRight: "25px", paddingTop: "20px"}}>
                                            <span>Σύνολο πελατών</span><br/>
                                            <span style={{
                                                fontWeight: "600",
                                                fontSize: "20px",
                                                marginTop: "15px"
                                            }}>{dashboardData?.totalClients}</span>
                                        </div>
                                        <div style={{position: "absolute", bottom: 0, left: 0, width: "100%"}}>
                                            <div style={{ borderBottomLeftRadius: "12px", borderBottomRightRadius: "12px", overflow: "hidden", marginBottom: "-1px" }}>
                                                <SmallClientChart/>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row style={{marginTop: "20px"}}>
                                <Col md={6} className={"pt-2"}>
                                    <div style={monthlySalesBoxStyle}>
                                        <div>{company.year === moment().year() ? "Μηνιαίες Πωλήσεις" : "Ετήσιες Πωλήσεις"}</div>
                                        <div style={{
                                            fontWeight: "600",
                                            fontSize: "22px",
                                            paddingBottom: "30px",
                                        }}>{getGreekCurrencyFormat(company.year === moment().year() ? dashboardData?.monthlySales : dashboardData?.yearlySales)}</div>
                                        {company.year === moment().year() &&
                                            <>
                                                <div style={{
                                                    fontWeight: "600",
                                                    opacity: "0.80",
                                                    fontSize: "16px",
                                                    color: "#ba68c8",
                                                    fontStyle: "italic",
                                                }}>{dashboardData?.monthlySalesPercentage}%
                                                </div>
                                                <div style={{fontSize: "12px", paddingBottom: "10px"}}>Σε σχέση με την
                                                    ίδια μέρα τον προηγούμενο μήνα
                                                </div>
                                            </>}
                                    </div>
                                </Col>
                                <Col md={6} className={"pt-2"}>
                                    <div style={monthlyClientPaymentsBoxStyle}>
                                        <div>{company.year === moment().year() ? "Μηνιαίες Εισπράξεις" : "Ετήσιες Εισπράξεις"}</div>
                                        <div style={{
                                            fontWeight: "600",
                                            fontSize: "22px",
                                            paddingBottom: "30px",
                                        }}>{getGreekCurrencyFormat(company.year === moment().year() ? dashboardData?.monthlyPayments : dashboardData?.yearlyPayments)}</div>
                                        {company.year === moment().year() &&
                                            <>
                                                <div style={{
                                                    fontWeight: "600",
                                                    fontSize: "16px",
                                                    color: "#ba68c8",
                                                    fontStyle: "italic",
                                                }}>{dashboardData?.monthlyPaymentsPercentage}%
                                                </div>
                                                <div style={{fontSize: "12px", paddingBottom: "10px"}}>Σε σχέση με την
                                                    ίδια μέρα τον προηγούμενο μήνα
                                                </div>
                                            </>}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6} className={"p-1"}>
                            <OverviewChart2/>
                        </Col>
                    </Row>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <h2>Πίνακας Ελέγχου</h2>
                    <h6>Καλώς ορίσατε στο Primer
                        ERP, {formatGreekName(currentUser.firstName)} {formatGreekName(currentUser.lastName, true)}!</h6>
                </React.Fragment>
            )}
            <Row className={"mt-2 mb-3"}>
                <Col md={6}>
                    <div style={{
                        height: bottomBoxHeight,
                        width: "100%",
                        backgroundColor: "var(--light-skyblue)",
                        borderRadius: "8px",
                        padding: "10px",
                        overflowY: "scroll",
                        overflowX: "hidden"
                    }}>
                        <div style={{textAlign: "center", fontSize: "20px", fontWeight: "600"}} className={"mb-2"}>Νέα -
                            Ειδήσεις
                        </div>
                        {newsData.length > 0 && newsData.map((article, index) => (
                            <div
                                key={`article ${index}`}
                                onClick={() => handleNewsClick(article)}
                                style={{
                                    padding: "10px",
                                    backgroundColor: "white",
                                    borderRadius: "8px",
                                    boxShadow: "0px 2px 4px -1px lightgray",
                                    lineHeight: "1.5em",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                }}
                                className={"mb-2 dashboard-article"}
                            >
                                <div className={"mb-1"}
                                     style={{fontSize: "18px", fontWeight: "600"}}>{article.title}</div>
                                {article.content && (
                                    <div dangerouslySetInnerHTML={{__html: truncateHTML(article.content, 200)}}></div>
                                )}
                                {article.pubDate && (
                                    <div className={"text-muted"} style={{textAlign: "right"}}>{moment(article.pubDate).format("DD/MM/YYYY HH:mm")}</div>
                                )}
                            </div>
                        ))}
                    </div>
                </Col>
                <Col md={6}>
                    <div style={{
                        height: bottomBoxHeight,
                        width: "100%",
                        borderRadius: "12px",
                        backgroundColor: "var(--light-skyblue)",
                        overflowY: "auto",
                        overflowX: "hidden",
                    }}>
                        <div style={{alignItems: "center", padding: "12px", borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}>
                            <Row style={{textAlign: "center"}}>
                                <Col md={9}>
                                    <span style={{fontSize: "16px", fontWeight: "600"}}>Αναφορά αποτελεσμάτων συγχρονισμού παραστατικών από λοιπές εφαρμογές</span>
                                </Col>
                                <Col md={3} className={"text-right"}>
                                    <Button
                                        className={"mt-1 p-1"}
                                        size="sm"
                                        disabled={syncLoader}
                                        onClick={() => dispatch(triggerCleanFailedSyncs(company.id, setSyncLoader))}
                                        title={"Καθαρισμός αποτυχημένων"}
                                    >
                                        <MdCleaningServices size={20} />
                                    </Button>
                                    <Button
                                        disabled={syncLoader}
                                        style={{marginLeft: "auto", marginRight: "10px"}}
                                        className={"ml-2 mt-1 p-1"}
                                        size="sm"
                                        onClick={() => dispatch(triggerSyncProviderInvoices(company.id, setSyncLoader))}
                                        title={"Ενημέρωση"}
                                    >
                                        {!syncLoader && (
                                            <FaArrowsRotate size={20} />
                                        )}
                                        {syncLoader && (
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        )}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                        <Row className={"mt-2"}>
                            <Col md={12}>
                                <Table style={{width: "100%", tableLayout: "fixed", wordBreak: "break-word"}}
                                       hover={true} striped={true} size={"sm"}>
                                    <colgroup>
                                        <col style={{width: "12%"}}/>
                                        <col style={{width: "14%"}}/>
                                        <col style={{width: "14%"}}/>
                                        <col style={{width: "14%"}}/>
                                        <col style={{width: "14%"}}/>
                                        <col style={{width: "12%"}}/>
                                        <col style={{width: "90px"}}/>
                                    </colgroup>
                                    <thead>
                                    <tr style={{backgroundColor: "white", textAlign: "center"}}>
                                        <th>Ημερομηνία</th>
                                        <th>Σύνολο συγχρονισμένων</th>
                                        <th>Σύνολο Καθαρής Αξίας</th>
                                        <th>Σύνολο ΦΠΑ</th>
                                        <th>Συνολική Αξία</th>
                                        <th>Σύνολο Αποτυχημένων</th>
                                        <th>Σφάλματα</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {(syncInvoicesProviderLog?.syncs || []).map((row, idx) => (
                                        <tr key={`startSyncTable-${idx}`} style={{
                                            backgroundColor: idx % 2 === 0 ? "white" : "lightgray",
                                            textAlign: "center",
                                            height: "55px"
                                        }}>
                                            <td>{moment(row.syncDate).format("DD-MM-YYYY HH:mm")}</td>
                                            <td>{row.totalInvoicesSynced}</td>
                                            <td>{getGreekCurrencyFormat(row.totalNetValue)}</td>
                                            <td>{getGreekCurrencyFormat(row.totalVatValue)}</td>
                                            <td>{getGreekCurrencyFormat(row.totalValue)}</td>
                                            <td>{row.totalFailed}</td>
                                            <td>
                                                <Button
                                                    disabled={syncInvoicesProviderLog?.syncs.find(sync => sync._id === row._id)?.logs.length === 0}
                                                    style={{
                                                        alignSelf: 'center',
                                                        display: "inline-block",
                                                        padding: "6px",
                                                        maxWidth: "100%",
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                    }}
                                                    size={"sm"}
                                                    title={"Εμφάνιση"}
                                                    onClick={() => setShowModal(row._id)}>Εμφάνιση</Button>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>

            <Modal className="themeModalBig" show={showLogModal} onHide={() => setShowLogModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Σφάλματα</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {displayedLogs && displayedLogs.length > 0 && (
                        <div>
                            {displayedLogs.map((log) => (
                                <>
                                    <div>{log?.invoiceData}</div>
                                    <div>Μήνυμα Λάθους: {log?.message}</div>
                                    <hr/>
                                </>
                            ))}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowLogModal(false)}>ΟΚ</Button>
                </Modal.Footer>
            </Modal>

            <Modal dialogClassName={"modal65PercentWidth"} show={showNewsModal} onHide={() => handleCloseNewsModal()}>
                <Modal.Header closeButton onClick={() => handleCloseNewsModal()}>
                    <Modal.Title>{(activeNewsArticle !== null) && <div>{activeNewsArticle.title ?? ""}</div>}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{maxHeight: "65vh", overflowY: "auto"}}>
                        {
                            activeNewsArticle &&
                            <div dangerouslySetInnerHTML={{__html: activeNewsArticle.content ?? ""}}></div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {!isEmpty(activeNewsArticle) && (
                        <div className={"text-muted"} style={{textAlign: "right"}}>{moment(activeNewsArticle.pubDate).format("DD/MM/YYYY HH:mm")}</div>
                    )}
                </Modal.Footer>
            </Modal>

            {isDemoCompany && (
                <Modal show={showConfirmReset} onHide={() => setShowConfirmReset(false)} backdrop={"static"}>
                    <Modal.Header closeButton>
                        <Modal.Title>Επαναφορά δοκιμαστικής εταιρείας</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Είσαστε σίγουροι ότι θέλετε να επαναφέρετε την δοκιμαστική εταιρεία στην αρχική της κατάσταση;
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => handleResetDemoCompany()}>
                            Επαναφορά
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    )
}

export default Start;
